import "E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\core-js\\modules\\es6.promise.js";
import "E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\core-js\\modules\\es7.promise.finally.js";
/*
 * @Descripttion:
 * @version:
 * @Author: 王凯
 * @LastEditors: 王凯
 */
import Vue from "vue";
import Cookies from "js-cookie";
import "normalize.css/normalize.css";
import waves from "./directive/waves";
import throttle from "./directive/throttle";
import tableHeight from "./directive/table-height";
import clipboard from "./directive/clipboard";
import Element from "element-ui";
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";

// 数据字典
import dict from "./components/Dict";

// 权限指令
import checkPer from "@/utils/permission";
import permission from "./components/Permission";
import "./assets/styles/element-variables.scss";
// global css
import "./assets/styles/index.scss";

// 代码高亮
// import VueHighlightJS from 'vue-highlightjs'
// import 'highlight.js/styles/atom-one-dark.css'
import App from "./App";
import store from "./store";
import router from "./router/routers";
//对话框文件
import "@/components/Dialog/register";
import "./assets/icons"; // icon
import "./router/index"; // permission control
import "echarts-gl";

// 注册TeamtreeAndCar
import TeamtreeAndCar from "./components/TeamtreeAndCar/index";
import selectLazyLoad from "./components/SelectLazyLoad/index.js";
import selectLocalLoad from "./components/SelectLocalLoad/index.js";
import ykCarNumberSelect from "./components/ykCarNumberSelect/index.js";
import TagExtend from "./components/tagExtend/index.js";
import ContantSearch from "./components/ContantSearch/index.js";
import "./components/index";

// 视频播放插件
import VideoPlayer from "vue-video-player/src";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import "./filters"; // 过滤器
import moment from "moment"; // 导入文件
Vue.prototype.$moment = moment; // 赋值使用
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: process.env.VUE_APP_AK_API
});
// 引入qiankun
// import startQiankui from './micro/index';

Vue.use(checkPer);
// Vue.use(VueHighlightJS)
Vue.use(mavonEditor);
Vue.use(permission);
Vue.use(dict);
Vue.use(TeamtreeAndCar);
Vue.use(selectLazyLoad);
Vue.use(selectLocalLoad);
Vue.use(ykCarNumberSelect);
Vue.use(TagExtend);
Vue.use(waves);
Vue.use(throttle);
Vue.use(tableHeight);
Vue.use(clipboard);
Vue.use(VideoPlayer);
Vue.use(ContantSearch);
Vue.use(Element, {
  size: Cookies.get("size") || "small" // set element-ui default size
});
Vue.config.productionTip = false;
Vue.prototype.$filterObj = function (obj) {
  var cloneObj = _.cloneDeep(obj);
  if (cloneObj.time) {
    delete cloneObj.time;
  }
  var resObj = {};
  for (var key in cloneObj) {
    if (cloneObj[key] === 0 || cloneObj[key]) {
      resObj[key] = cloneObj[key];
    }
  }
  return resObj;
  // return _.pickBy(cloneObj, _.identity)
};
new Vue({
  el: "#app",
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});

// startQiankui();